import { render, staticRenderFns } from "./RoleGroupModal.vue?vue&type=template&id=fb31393a"
import script from "./RoleGroupModal.vue?vue&type=script&lang=ts"
export * from "./RoleGroupModal.vue?vue&type=script&lang=ts"
import style0 from "./RoleGroupModal.vue?vue&type=style&index=0&id=fb31393a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports